<template>
  <div id="EnlargeGalleryImage" class="modal-area">
    <div class="modal-overlay" @click="enlargeImg('')"></div>
    <div class="modal-body">
      <img class="pet-image" :src="pet_image" />
      <span class="close-button" @click="enlargeImg('')">
        <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7 1L1 7L7 13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
    </div>
</div>
</template>
<script>
// import {db} from '@/_firebase/init';
// import {mapState, mapActions} from 'vuex'

export default {
  name: 'EnlargeGalleryImage',
  props: ['pet_image'],
  data(){
    return{
    errors: [],
    }
  },
  methods:{
    enlargeImg(){
      this.$emit('enlargeImg', '')
    }
  }
}
</script>
<style scoped>

#EnlargeGalleryImage{
  position: fixed;
  top:0;
  box-sizing: border-box;
  left:0;
  z-index: 24;
  width: 100%;
  height: 105%;
  display:flex;
  align-items:center;
  justify-content:center;
  overflow: hidden;
  transition:1s;
}
.close-button{
  position: absolute;
  z-index:99;
  width: 32px;
  height: 32px;
  left: 6.8%;
  top: 60px;
  padding:2px;
  color:#121826;
  background: #F7F7FB;
  cursor: pointer;
  border-radius: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.close-button:active{
  background:#6266F9;
  color:white;
}

.modal-overlay{
  position: absolute;
  top: 0;
  left: 0;
  background-color: #222;
  width: 100%;
  height: 110%;
  opacity: .7;
}
.modal-body{
     max-width: 100%;
    margin: auto;
    z-index: 20;
    height: 100%;
    background: white;
    /* background: bottom; */
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}
.pet-image{
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover; 
  overflow:hidden;
  text-align: center;
  max-height:100%;
  transition:1s; 
}
.exit-btn{
  /* bottom: 1rem; */
  right: 0rem;
  position: absolute;
  display:flex;
  align-items:center;
  justify-content:center;
  font-size: 1.5rem;
  color: #fff;
  transition:1s;
}
.exit-btn img{
  margin-left:1rem;;
  width: 3rem;
  height: 3rem;
}
.close-btn{
  top: 0;
}
body[data-theme='dark'] .modal-body{
  background-color: var(--bg-dark);
  color: var(--text-dark);
}
</style>
